import { render } from "./AltNavigationBar.vue?vue&type=template&id=0d0e5727&scoped=true"
import script from "./AltNavigationBar.vue?vue&type=script&lang=js"
export * from "./AltNavigationBar.vue?vue&type=script&lang=js"

import "./AltNavigationBar.vue?vue&type=style&index=0&id=0d0e5727&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0e5727"]])

export default __exports__